import { Menu } from '@/src/components/ui/Menu'
import { OpacityOverlay } from '../../OpacityOverlay'
import { CompanySelectButton } from './CompanySelectButton'
import { CompanySelectMenuList } from './CompanySelectMenuList'
import { useCompanySelect } from './useCompanySelect.hook'

export const CompanySelect = () => {
  const {
    hoveredCompanyIndex,
    selectedCompanyIndex,
    activeSearchBoxId,
    companyOptions,
    companySearchTerm,
    setActiveSearchBoxId,
    handleCompanyHoveredChange,
    handleCompanySearch,
    handleSubmit,
  } = useCompanySelect()

  const menuIsDisabled = companyOptions.length === 1

  return (
    <Menu closeOnSelect={false} placement='right-end' flip={true}>
      {({ isOpen }) => {
        return (
          <>
            <CompanySelectButton disabled={menuIsDisabled} />
            <CompanySelectMenuList
              isOpen={isOpen}
              activeSearchBoxId={activeSearchBoxId}
              setActiveSearchBoxId={setActiveSearchBoxId}
              onClick={handleSubmit}
              companyOptions={companyOptions}
              hoveredCompanyIndex={hoveredCompanyIndex}
              companySearchTerm={companySearchTerm}
              handleCompanySearch={handleCompanySearch}
              handleCompanyHoveredChange={handleCompanyHoveredChange}
              selectedCompanyIndex={selectedCompanyIndex}
            />
            <OpacityOverlay isOpen={isOpen} />
          </>
        )
      }}
    </Menu>
  )
}
